export const SIGN_IN_PATH = '/sign-in';
export const HOME_PATH = '/home';
export const ADMIN_PATH = '/admin-page';

export const ROUTES_BAR = {
  [HOME_PATH]: [{ title: 'pageTitles.home', path: HOME_PATH }],
  [ADMIN_PATH]: [
    { title: 'pageTitles.home', path: HOME_PATH },
    { title: 'Nursapa', path: ADMIN_PATH },
  ],
};
